import {
  Badge,
  createSortableColumn,
  DataTable,
  Modal,
  type TanstackReactTable,
} from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { useDepartmentPositionsQuery } from "../api/queries";

type PositionRow = {
  id: string;
  title: string;
  departmentId: string;
  parentId: string | null;
  level: number;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
};

type DepartmentPositionsModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  departmentId?: string;
  departmentName?: string;
};

export function DepartmentPositionsModal({
  open,
  onOpenChange,
  departmentId,
  departmentName,
}: DepartmentPositionsModalProps) {
  const nav = useNavigate({ from: "/app/departments" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/departments" });

  const positions = useDepartmentPositionsQuery(departmentId ?? "", {
    offset: 0,
    limit: 50,
  });

  const columns: TanstackReactTable.ColumnDef<PositionRow>[] = [
    createSortableColumn<PositionRow>("title", "ຊື່ຕໍາແໜ່ງ", { size: 200 }),
    {
      id: "level",
      header: "ລະດັບ",
      cell: ({ row }) => <span className="text-sm">{row.original.level}</span>,
      size: 80,
    },
    {
      id: "status",
      header: "ສະຖານະ",
      cell: ({ row }) =>
        row.original.status ? (
          <Badge variant="default">ໃຊ້ງານ</Badge>
        ) : (
          <Badge variant="secondary">ບໍ່ໃຊ້ງານ</Badge>
        ),
      size: 100,
    },
  ];

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`ຕໍາແໜ່ງໃນພະແນກ: ${departmentName || ""}`}
      size="lg"
      description={`ຈໍານວນທັງໝົດ: ${positions.data?.meta?.total ?? 0} ຕໍາແໜ່ງ`}
    >
      <div className="max-h-[calc(100vh-12rem)] overflow-y-auto">
        <DataTable<PositionRow, unknown>
          noDataMessage="ບໍ່ມີຕໍາແໜ່ງໃນພະແນກນີ້"
          isLoading={positions.isLoading}
          columns={columns}
          data={positions.data?.data ?? []}
          offset={0}
          limit={50}
          totalCount={positions.data?.meta?.total ?? 0}
          onPaginationChange={() => {}}
        />
      </div>
    </Modal>
  );
}
